import React, { Component } from "react";
import {
  Button,
  Card,
  Col,
  Row,
  Badge,
  Form,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

export default class DeploymentExecutionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      readyRequests: [],
      executions: [],
      showDeploy: false,
      selectedRequest: null,
      // Deploy form
      executionType: "Full",
      serverName: "",
      environment: "",
      filesDeployed: "",
      packagesDeployed: "",
      dbQueriesExecuted: "",
      executionRemarks: "",
      // Execution list columns
      executionColumns: [
        {
          name: "ID",
          selector: (row) => row.deploymentexecution_Id,
          sortable: true,
          width: "70px",
        },
        {
          name: "Request",
          selector: (row) => row.deploymentRequest_Id,
          sortable: true,
          width: "90px",
        },
        {
          name: "Type",
          selector: (row) => row.executionType,
          width: "90px",
        },
        {
          name: "Server",
          selector: (row) => row.serverName,
        },
        {
          name: "Environment",
          selector: (row) => row.environment,
          width: "120px",
        },
        {
          name: "Status",
          selector: (row) => row.executionStatus,
          cell: (row) => {
            const colors = {
              Pending: "secondary",
              InProgress: "warning",
              Completed: "success",
              Failed: "danger",
              RolledBack: "dark",
            };
            return (
              <Badge bg={colors[row.executionStatus] || "secondary"}>
                {row.executionStatus}
              </Badge>
            );
          },
          width: "120px",
        },
        {
          name: "Start Time",
          selector: (row) => row.executionStartTime,
          width: "160px",
        },
        {
          name: "End Time",
          selector: (row) => row.executionEndTime,
          width: "160px",
        },
        {
          name: "Actions",
          cell: (row) => (
            <div>
              {row.executionStatus === "InProgress" && (
                <>
                  <Button
                    size="sm"
                    variant="success"
                    className="me-1"
                    onClick={() => this.updateExecution(row, "Completed")}
                  >
                    Complete
                  </Button>
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={() => this.updateExecution(row, "Failed")}
                  >
                    Failed
                  </Button>
                </>
              )}
            </div>
          ),
          width: "200px",
        },
      ],
      readyColumns: [
        {
          name: "Request Code",
          selector: (row) => row.requestCode,
          sortable: true,
        },
        {
          name: "Project",
          selector: (row) => row.projectName,
          sortable: true,
        },
        {
          name: "Type",
          selector: (row) => row.requestType,
          cell: (row) => (
            <Badge bg={row.requestType === "UI" ? "primary" : "success"}>
              {row.requestType || "N/A"}
            </Badge>
          ),
          width: "80px",
        },
        {
          name: "Environment",
          selector: (row) => row.targetEnvironment,
          sortable: true,
          width: "120px",
        },
        {
          name: "Priority",
          selector: (row) => row.priority,
          sortable: true,
          width: "100px",
        },
        {
          name: "Reason",
          selector: (row) => row.reasonForDeployment,
          wrap: true,
        },
        {
          name: "Actions",
          cell: (row) => (
            <Button
              size="sm"
              variant="warning"
              onClick={() => this.openDeployForm(row)}
            >
              Deploy
            </Button>
          ),
          width: "100px",
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchReadyRequests();
    this.fetchExecutions();
  }

  fetchReadyRequests = () => {
    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentexecution/readylist", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ readyRequests: data.list });
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  fetchExecutions = () => {
    fetch(configData.api_url + "C_Deploymentexecution/list", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ executions: data.list });
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  openDeployForm = (request) => {
    this.setState({
      showDeploy: true,
      selectedRequest: request,
      environment: request.targetEnvironment || "",
      executionType: "Full",
      serverName: "",
      filesDeployed: "",
      packagesDeployed: "",
      dbQueriesExecuted: "",
      executionRemarks: "",
    });
  };

  handleDeploy = () => {
    const { selectedRequest } = this.state;
    if (!selectedRequest) return;

    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    frmdata.append(
      "deploymentRequest_Id",
      selectedRequest.deploymentrequests_Id,
    );
    frmdata.append("executionType", this.state.executionType);
    frmdata.append("serverName", this.state.serverName);
    frmdata.append("environment", this.state.environment);
    frmdata.append("filesDeployed", this.state.filesDeployed);
    frmdata.append("packagesDeployed", this.state.packagesDeployed);
    frmdata.append("dbQueriesExecuted", this.state.dbQueriesExecuted);
    frmdata.append("executionRemarks", this.state.executionRemarks);
    frmdata.append("executionStatus", "InProgress");
    frmdata.append(
      "executionStartTime",
      new Date().toISOString().slice(0, 19).replace("T", " "),
    );

    fetch(configData.api_url + "C_Deploymentexecution/add", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          toast.success("Deployment started successfully");
          this.setState({ showDeploy: false });
          this.fetchReadyRequests();
          this.fetchExecutions();
        } else {
          toast.error(data.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Failed to start deployment");
      });
  };

  updateExecution = (execution, status) => {
    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    frmdata.append("deploymentexecution_Id", execution.deploymentexecution_Id);
    frmdata.append("deploymentRequest_Id", execution.deploymentRequest_Id);
    frmdata.append("executionStatus", status);
    frmdata.append(
      "executionEndTime",
      new Date().toISOString().slice(0, 19).replace("T", " "),
    );

    fetch(configData.api_url + "C_Deploymentexecution/update", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          toast.success("Deployment marked as " + status);
          this.fetchReadyRequests();
          this.fetchExecutions();
        } else {
          toast.error(data.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Failed to update deployment");
      });
  };

  render() {
    return (
      <div className="container-fluid p-3">
        <h4>Deployment Execution</h4>
        <p className="text-muted">
          Deploy approved requests manually. Manage files, packages, and DB
          changes.
        </p>

        {/* Ready for deployment */}
        <Card className="mb-3">
          <Card.Header>
            <strong>
              Approved Requests - Ready for Deployment (
              {this.state.readyRequests.length})
            </strong>
          </Card.Header>
          <Card.Body>
            <DataTable
              columns={this.state.readyColumns}
              data={this.state.readyRequests}
              pagination
              highlightOnHover
              striped
              noDataComponent="No requests ready for deployment"
            />
          </Card.Body>
        </Card>

        {/* Execution history */}
        <Card>
          <Card.Header>
            <strong>Deployment Execution History</strong>
          </Card.Header>
          <Card.Body>
            <DataTable
              columns={this.state.executionColumns}
              data={this.state.executions}
              pagination
              highlightOnHover
              striped
              defaultSortFieldId={1}
              defaultSortAsc={false}
              paginationPerPage={100}
              keyField="id"
              paginationRowsPerPageOptions={[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
              ]}
              onChangeRowsPerPage={this.handlePerRowsChange}
              onChangePage={this.handlePageChange}
            />
          </Card.Body>
        </Card>

        {/* Deploy Offcanvas */}
        <Offcanvas
          show={this.state.showDeploy}
          onHide={() => this.setState({ showDeploy: false })}
          placement="end"
          style={{ width: "50%" }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              Deploy Request: {this.state.selectedRequest?.requestCode || ""}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {this.state.selectedRequest && (
              <div className="mb-3 p-2 bg-light rounded">
                <strong>Project:</strong>{" "}
                {this.state.selectedRequest.projectName}
                <br />
                <strong>Type:</strong> {this.state.selectedRequest.requestType}
                <br />
                <strong>Environment:</strong>{" "}
                {this.state.selectedRequest.targetEnvironment}
                <br />
                <strong>Reason:</strong>{" "}
                {this.state.selectedRequest.reasonForDeployment}
              </div>
            )}

            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Execution Type</Form.Label>
                <Form.Select
                  value={this.state.executionType}
                  onChange={(e) =>
                    this.setState({ executionType: e.target.value })
                  }
                >
                  <option value="Full">Full Deployment</option>
                  <option value="Files">Files Only</option>
                  <option value="Packages">Packages Only</option>
                  <option value="DBChanges">DB Changes Only</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Server Name</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.serverName}
                  onChange={(e) =>
                    this.setState({ serverName: e.target.value })
                  }
                  placeholder="Enter server name or IP"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Environment</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.environment}
                  onChange={(e) =>
                    this.setState({ environment: e.target.value })
                  }
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Files to Deploy</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={this.state.filesDeployed}
                  onChange={(e) =>
                    this.setState({ filesDeployed: e.target.value })
                  }
                  placeholder="List files to be deployed (one per line)"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Packages to Deploy</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={this.state.packagesDeployed}
                  onChange={(e) =>
                    this.setState({ packagesDeployed: e.target.value })
                  }
                  placeholder="npm packages, composer packages, etc."
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>DB Queries to Execute</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={this.state.dbQueriesExecuted}
                  onChange={(e) =>
                    this.setState({ dbQueriesExecuted: e.target.value })
                  }
                  placeholder="SQL queries to run during deployment"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Remarks</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={this.state.executionRemarks}
                  onChange={(e) =>
                    this.setState({ executionRemarks: e.target.value })
                  }
                  placeholder="Any deployment notes"
                />
              </Form.Group>

              <Button variant="warning" onClick={this.handleDeploy}>
                Start Deployment
              </Button>
            </Form>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    );
  }
}
